// Recovered compiled webpack factory 7511. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  Object.defineProperty(t, "A", {
    enumerable: !0,
    get: function () {
      return u;
    },
  });
  let n = r(28406),
    a = r(87037),
    o = r(77700),
    i = r(61940),
    s = r(51755),
    l = r(40579);
  function u(e, t, r, u, c, f) {
    let d,
      p = !1,
      h = !1,
      _ = (0, l.parseRelativeUrl)(e),
      m = (0, o.removeTrailingSlash)(
        (0, i.normalizeLocalePath)((0, s.removeBasePath)(_.pathname), f).pathname,
      ),
      g = (r) => {
        let l = (0, n.getPathMatch)(r.source + "", { removeUnnamedParams: !0, strict: !0 })(
          _.pathname,
        );
        if ((r.has || r.missing) && l) {
          let e = (0, a.matchHas)(
            {
              headers: { host: document.location.hostname, "user-agent": navigator.userAgent },
              cookies: document.cookie.split("; ").reduce((e, t) => {
                let [r, ...n] = t.split("=");
                return ((e[r] = n.join("=")), e);
              }, {}),
            },
            _.query,
            r.has,
            r.missing,
          );
          e ? Object.assign(l, e) : (l = !1);
        }
        if (l) {
          if (!r.destination) return ((h = !0), !0);
          let n = (0, a.prepareDestination)({
            appendParamsToQuery: !0,
            destination: r.destination,
            params: l,
            query: u,
          });
          if (
            ((_ = n.parsedDestination),
            (e = n.newUrl),
            Object.assign(u, n.parsedDestination.query),
            (m = (0, o.removeTrailingSlash)(
              (0, i.normalizeLocalePath)((0, s.removeBasePath)(e), f).pathname,
            )),
            t.includes(m))
          )
            return ((p = !0), (d = m), !0);
          if ((d = c(m)) !== e && t.includes(d)) return ((p = !0), !0);
        }
      },
      y = !1;
    for (let e = 0; e < r.beforeFiles.length; e++) g(r.beforeFiles[e]);
    if (!(p = t.includes(m))) {
      if (!y) {
        for (let e = 0; e < r.afterFiles.length; e++)
          if (g(r.afterFiles[e])) {
            y = !0;
            break;
          }
      }
      if ((y || ((d = c(m)), (y = p = t.includes(d))), !y)) {
        for (let e = 0; e < r.fallback.length; e++)
          if (g(r.fallback[e])) {
            y = !0;
            break;
          }
      }
    }
    return { asPath: e, parsedAs: _, matchedPage: p, resolvedHref: d, externalDest: h };
  }
}
